var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 934.632,
    height: 923.274,
    viewBox: "0 0 934.632 923.274",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pencil",
    d: "M16.073,909.929l.168.166a49.329,49.329,0,0,0,34.742,14.3,50.223,50.223,0,0,0,16-2.634l280.209-93.9L884.874,296.7a171.669,171.669,0,0,0-.026-244.876c-68.459-67.614-179.441-67.6-247.885.028L99.28,583.024,4.23,859.835a48.016,48.016,0,0,0,11.843,50.122ZM681.614,95.965C725.4,52.7,796.408,52.7,840.2,95.962a109.832,109.832,0,0,1,0,156.666l-70.693,69.858L610.9,165.8ZM154.339,616.846,566.247,209.905,724.831,366.566,312.923,773.479,72.928,853.9Z",
    transform: "translate(-1.569 -1.126)",
    fill: "#d0740b"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.10dc581e.svg";
export { ForwardRef as ReactComponent };